import {createElement, Component, PropTypes} from 'rlink-react';
import {IntlProvider} from 'react-intl';
import {Provider} from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {Modal} from 'rlink-modal/component';
import TooltipContainer from 'rlink-tooltips/TooltipContainer';
import BuildContext from 'rlink-router/BuildContext';

export default class MountRootComponent extends Component {
  getChildContext () {
    return {
      buildContext: this.props.buildContext,
    };
  }

  render () {
    let {
      store,
      locale,
      messages,
      mountedContent,
      onCloseModal,
      flyouts,
      modals,
      tooltip,
      nextTransition,
    } = this.props;
    return <Provider store={store}>
      <IntlProvider
        key={locale}
        locale={locale}
        messages={messages}>
        <div className={locale}>
          {mountedContent}
          <ReactCSSTransitionGroup
            transitionName={nextTransition}
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}>
            {modals.map(
              (modal, idx) => <Modal
                stackIdx={idx}
                stackSize={modals.length}
                key={idx}
                nudgeOffset={modals[0].nudgeOffset}
                closeModal={() => {
                  onCloseModal();
                  modal.onClose && modal.onClose();
                }}
                fullscreen={modal.fullscreen}
                bindOnCloseToClassNames={modal.bindOnCloseToClassNames}
                open>
                {modal.content}
              </Modal>
            )}
          </ReactCSSTransitionGroup>
          {Object.entries(flyouts).map(
            ([name, flyout]) => <Modal
              key={name}
              isFlyout
              open>
              {flyout}
            </Modal>
          )}
          {<TooltipContainer>{tooltip && tooltip.content}</TooltipContainer>}
        </div>
      </IntlProvider>
    </Provider>;
  }
}



MountRootComponent.propTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
  store: PropTypes.object, // fun fact: redux doesn't actually export Store, so we can't use instanceOf(Store)
  locale: PropTypes.string,
  mountedContent: PropTypes.node,
  messages: PropTypes.objectOf(PropTypes.string),
  flyouts: PropTypes.objectOf(PropTypes.node),
  modals: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.node,
  onCloseModal: PropTypes.func,
  nextTransition: PropTypes.string,
};

MountRootComponent.defaultProps = {
  tooltip: null,
  modals: [],
  flyouts: {},
  transitionTimeout: 250,
  onCloseModal: () => null,
  nextTransition: '',
};

MountRootComponent.childContextTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
};



// WEBPACK FOOTER //
// ./lib/rlink-router/MountRootComponent.jsx